"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var TypeformPopupButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TypeformPopupButton"));
var single_1 = require("utils/selectors/single");
var SearchBar_1 = __importDefault(require("../../atomicComponents/organisms/SearchBar"));
var TransactionContactTableMenu = function (_a) {
    var searchText = _a.searchText, setSearchText = _a.setSearchText, showAll = _a.showAll, setShowAll = _a.setShowAll;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", width: 670, my: 2, ml: -2 }, { children: [(0, jsx_runtime_1.jsx)(TypeformPopupButton_1.default, __assign({ typeFormID: "OAOmUOAo", icon: faPlus_1.faPlus, variant: "text", size: "small", hidden: {
                    userid: profile.id,
                    email: profile === null || profile === void 0 ? void 0 : profile.email,
                    companyid: profile === null || profile === void 0 ? void 0 : profile.companyId,
                } }, { children: "Add a Missing Tool" })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ size: "small", onClick: function () { return setShowAll(!showAll); }, color: showAll ? 'primary' : 'neutral' }, { children: "Show ".concat(showAll ? 'only to do' : 'all') })), (0, jsx_runtime_1.jsx)(SearchBar_1.default, { searchText: searchText, setSearchText: setSearchText })] })));
};
exports.default = TransactionContactTableMenu;
